import React from 'react';
import DragAndDropItemWrapper from "Components/Common/components/DragAndDrop/DragAndDropItemWrapper"
import { GripIcon, TimesIcon } from "assests/GmsIcons"
import { DraggableProvided, DraggableRubric, DraggableStateSnapshot } from "react-beautiful-dnd"
import { ThandleRemove } from "types/Components/Common/Table/TableHeaderControlModal"
import { TTableHeader } from "types/Components/Common/Table/Table"

/**
 * Header contol modal dragable item
 * 
 * @param items - all the items to render
 * @param handleRemove - remove button handler
 * @returns 
 */
const DragAndDropHeaderItem = (items: TTableHeader[], handleRemove: ThandleRemove) => (className?: string) => (provided: DraggableProvided, snapshot: DraggableStateSnapshot, rubric: DraggableRubric) => (
    <DragAndDropItemWrapper provided={provided}>
         <div className={`!tw-cursor-move tw-flex tw-items-center tw-justify-between tw-bg-gray tw-p-1.5 tw-px-2.5 tw-rounded tw-w-[inherit] ${className}`}>
             <div className={`tw-flex tw-items-center tw-space-x-3`}>
                 <span>
                     <GripIcon/>
                 </span>
                 <span>
                     <p className={`tw-leading-5 tw-pointer-events-none tw-max-w-[220px] tw-truncate`}>{items[rubric.source.index].name}</p>
                 </span>
             </div>
             <div className={`tw-p-1 hover:tw-bg-[#E4E4E4] tw-rounded-sm tw-group tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-cursor-pointer`}>
                 <button onClick={(e) => handleRemove(e, rubric.source.index)} type="button" className={`tw-hidden group-hover:tw-block`}>
                     <span className={`tw-border !tw-border-dark tw-rounded-sm tw-flex tw-items-center tw-justify-center tw-text-dark tw-h-[13.5px] tw-w-[13.5px] `}>
                         <TimesIcon/>
                     </span>
                 </button>
             </div>
         </div>
     </DragAndDropItemWrapper>
 )

 export default DragAndDropHeaderItem